import axios from "axios";
import { instance } from "../network/ApiCall";

export async function fetchLogin(data: any) {
  const response = await instance.post("/register/login", data);
  return response.data;
}
export async function fetchCaptcha() {
  const response = await instance.post("/users/captcha");
  return response.data;
}
export async function fetchChangePass(data: any) {
  const response = await instance.post(
    `/users/user/resetPassword?userId=${data.userId}&oldPassword=${data.oldPassword}&newPassword=${data.newPassword}`
  );
  return response.data;
}
export async function fetchLogout() {
  const response = await instance.get(`/users/user/logout`);
  return response.data;
}
export async function fetchLogsTracker(data: any) {
  const response = await instance.post(`/admin/logging?moduleName=${data}`);
  return response.data;
}
